var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "bank_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17v-7h2v7H5Zm6 0v-7h2v7h-2Zm-9 4v-2h20v2H2Zm15-4v-7h2v7h-2ZM2 8V6l10-5 10 5v2H2Zm4.45-2h11.1L12 3.25 6.45 6Z",
    fill: "currentColor"
  })));
};
export { SvgBank as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBpZD0iaWNvbiI+PHBhdGggaWQ9InZlY3RvciIgZD0iTTUgMTdWMTBIN1YxN0g1Wk0xMSAxN1YxMEgxM1YxN0gxMVpNMiAyMVYxOUgyMlYyMUgyWk0xNyAxN1YxMEgxOVYxN0gxN1pNMiA4VjZMMTIgMUwyMiA2VjhIMlpNNi40NSA2SDE3LjU1TDEyIDMuMjVMNi40NSA2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9nPjwvc3ZnPg==";